import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Icon, MenuItem } from '@blueprintjs/core'
import { MultiSelect, ItemRenderer } from '@blueprintjs/select'

import { IState } from '../../../../store/reducers'
import { ITag } from '../../../../models'

type FilterTagInputProps = {
  operator: string;
  onChange: any;
  defaultFilledValue: any;
}


const FilterTagInput = ({ operator, onChange, defaultFilledValue }: FilterTagInputProps) => {
  const allTags = useSelector((state: IState) => state.tags.tags);
  const [selectedTags, setSelectedTags] = useState<ITag[]>([])
  const [tagListToShow, setTagListToShow] = useState(allTags);

  const fillTags = (tags: ITag[]) => {
    setSelectedTags(tags);
    onChange(tags);
  }

  useEffect(() => {
    if (Array.isArray(defaultFilledValue)) {
      const tags = allTags.filter(t => defaultFilledValue.includes(t.uid))
      fillTags(tags)
    } else if (typeof defaultFilledValue === 'string' && defaultFilledValue.length > 0) {
      const tagUids = defaultFilledValue.split(',')
      fillTags(allTags.filter(t => tagUids.includes(t.uid)))
    } else {
      fillTags([])
    }
  }, [])

  const onSearchTagChange = (text: any) => {
    setTagListToShow(allTags.filter((tag: any) => tag.name.toLowerCase().includes(text.toLowerCase())));
  };

  const isTagSelected = (tag: any) => {
    return selectedTags.findIndex((item: ITag) => item.uid === tag.uid) >= 0;
  };

  const removeFromTags = (tag: any) => {
    const tagIndex = selectedTags.findIndex((item) => item.uid === tag.uid || tag.key);
    const updatedTags = [...selectedTags];
    if (tagIndex >= 0) {
      updatedTags.splice(tagIndex, 1);
      setSelectedTags(updatedTags);
    }
    onChange(updatedTags);
    return updatedTags;
  };

  const handleFilledTags = (tag: ITag) => {
    let tags = [...selectedTags];
    if (selectedTags.findIndex(item => item.uid === tag.uid) >= 0) {
      tags = removeFromTags(tag);
    } else {
      tags.push(tag);
    }
    setSelectedTags(tags);
    onChange(tags);
  };

  const clearSelectedTags = () => {
    setSelectedTags([]);
    onChange([]);
  };

  const renderTag: ItemRenderer<ITag> = (tag, { handleClick, modifiers, query }) => {
    if (!modifiers.matchesPredicate) {
      return null;
    }
    return (
      <MenuItem
        icon={isTagSelected(tag) ? 'tick' : 'blank'}
        active={modifiers.active}
        disabled={modifiers.disabled}
        key={tag.uid}
        onClick={() => handleFilledTags(tag)}
        text={tag.name}
        shouldDismissPopover={false}
      />
    );
  };

  const generateTagItem = (tag: ITag) => {
    return (
      <div
        key={tag.uid}
      >
        {tag.name}
      </div>
    )
  };

  return (
    <MultiSelect
      fill={true}
      onQueryChange={onSearchTagChange}
      resetOnSelect={true}
      itemRenderer={renderTag}
      tagInputProps={{
        onRemove: removeFromTags,
        rightElement: <Icon icon={'cross'} onClick={() => clearSelectedTags()}
          style={{ color: '#aaa', margin: '8px', cursor: 'pointer' }} />,
      }}
      items={tagListToShow}
      tagRenderer={item => generateTagItem(item)}
      onItemSelect={handleFilledTags}
      noResults={<MenuItem disabled={true} text="No results." />}
      selectedItems={selectedTags}
    />
  )

}

export default FilterTagInput
